import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Observable, Subscription, filter, skip } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { selectResetted } from "src/app/store/auth/auth.selector";
import * as AuthActions from 'src/app/store/auth/auth.actions';
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { StandardNewValidator, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { Lang } from "src/app/model/lang";
import { selectCurrentLang } from "src/app/store/user/user.selector";
import { DEFAULT_LANG } from "src/app/conf/languages";
import { normalizeEmailControl } from "src/app/modules/shared/utils/strip-email-spaces";

@Component({
	templateUrl: './password-reset-modal.dialog.component.html',
})

export class PasswordResetModalDialogComponent implements OnInit, OnDestroy {
	resetted$: Observable<boolean | undefined>;
	resettedSub: Subscription | undefined;

	resetPasswordForm: FormGroup;

	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;

	// design
	screenWidth: number;
	MAX_MD_WIDTH = 1120;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	initSelectors() {
		this.resetted$ = this.store.select(selectResetted);
		this.currentLang$ = this.store.select(selectCurrentLang);
	}

	subscribeAll() {
		this.resettedSub = this.resetted$.pipe(
			skip(1),
			filter(r => !!r)
		).subscribe(() => {
			this.ref.close('success');
		});
		this.currentLang$.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
	}

	ngOnDestroy(): void {
		this.resettedSub?.unsubscribe();
	}

	buildForm(): void {
		this.resetPasswordForm = new FormGroup({
			'email': new FormControl('', [Validators.email, Validators.required]),
		});
	}

	get f(): any {
		return this.resetPasswordForm.controls;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		normalizeEmailControl(this.f.email);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.resetPasswordForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.resetPasswordForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	save(): void {
		this.store.dispatch(AuthActions.resetPassword({ email: this.f.email.value }));
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: PasswordResetModalDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: PasswordResetModalDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}
